module.exports = __webpack_public_path__ + "static/img/dcdc15796edebfc710fcb901f490f60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon1(1).png
// module id = OnSX
// module chunks = 1